import { ActivitySession } from '@activities/interfaces/activity-session';
import { BasicCalendarEvent } from '@bookings/interfaces/calendar';
import moment from 'moment';

export class CalendarHelper {
  public static PROFILE_EVENT_CONFLICT_BG_COLOR = '#5c9eff'; //'#ec7272'; //'#6B7280';
  public static PROFILE_EVENT_CONFLICT_BORDER_COLOR = '#5c9eff'; //'#ec7272'; //'#6B7280';

  public static PROFILE_EVENT_FREE_SLOT_BG_COLOR = 'transparent';
  public static PROFILE_EVENT_FREE_SLOT_BORDER_COLOR = 'transparent';

  public static PROFILE_EVENT_NOT_FREE_SLOT_BG_COLOR = '#D6E7FF'; //'#9CA3AF';
  public static PROFILE_EVENT_NOT_FREE_SLOT_BORDER_COLOR = '#D6E7FF'; //'#9CA3AF';

  public static PROFILE_EVENT_TMP_BG_COLOR = '#3ad783';
  public static PROFILE_EVENT_TMP_BORDER_COLOR = '#3ad783';

  public static PROFILE_EVENT_BG_COLOR = '#3ad783';
  public static PROFILE_EVENT_BORDER_COLOR = '#3ad783';

  public static fromActivitySessionsToCalendarEvents(
    activitySessions: ActivitySession[],
  ): BasicCalendarEvent[] {
    return activitySessions.map(item => {
      const sessionIsFull = item.max_participants && item.num_attendees >= item.max_participants;
      const now = moment();

      let startCriterion = true;
      let endCriterion = true;

      if (item.attendees_start_date_time) {
        const start = moment(item.attendees_start_date_time);
        startCriterion = start.isSameOrBefore(now);
      }

      if (item.attendees_end_date_time) {
        const end = moment(item.attendees_end_date_time);
        endCriterion = end.isSameOrAfter(now);
      }

      const sessionOutOfTheWindow = !(startCriterion && endCriterion);
      const sessionCanBeAttended = !sessionIsFull && !sessionOutOfTheWindow;
      const classes = [];

      if (sessionIsFull) {
        classes.push('max-participants-reached');
      } else if (sessionOutOfTheWindow) {
        classes.push('session-out-timerange');
      } else if (sessionCanBeAttended) {
        classes.push('session-attendees-allowed');
      }
      return {
        id: item.id,
        title: item.name,
        // entity: item,
        // my_custom_prop: `custom_prop_${1}`,
        activity: item?.activity,
        start: moment(item.start_date_time).toISOString(),
        end: moment(item.end_date_time).toISOString(),
        backgroundColor: item.activity?.color || null,
        borderColor: item.activity?.color || null,
        number_of_attendees: item.num_attendees || 0,
        className: classes,
        min_participants: item.min_participants || null,
        max_participants: item.max_participants || null,
        responsibles: item.responsibles.map(item => {
          return { id: item.id, fullname: item.fullname };
        }),
      };
    });
  }
}
